import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LOCALES } from './languages';

//? Le service worker utilise i18n.sw.js à la place de ce fichier (config-overrides.js)

//? Un chunk par langue : seules la langue active et fr-BE (langue de repli) sont téléchargées
const RESOURCES = {
    'fr-BE': () => import(/* webpackChunkName: "locale-fr-BE" */ './fr-BE.json'),
    'nl-BE': () => import(/* webpackChunkName: "locale-nl-BE" */ './nl-BE.json'),
    'en-US': () => import(/* webpackChunkName: "locale-en-US" */ './en-US.json'),
    'es-ES': () => import(/* webpackChunkName: "locale-es-ES" */ './es-ES.json'),
    'zh-CHT': () => import(/* webpackChunkName: "locale-zh-CHT" */ './zh-CHT.json')
};

const backend = {
    type: 'backend',
    read: (language, namespace, callback) => {
        if (!RESOURCES[language]) return callback(null, {});
        RESOURCES[language]().then(module => callback(null, module.default), error => callback(error, null));
    }
};

//? Ramène une langue détectée (navigateur, ancienne valeur du localStorage) à l'une des langues de l'application (nl-NL => nl-BE)
const convertDetectedLanguage = (language) => Object.keys(LOCALES).find(culture => culture.split('-')[0] === language.split('-')[0].toLowerCase()) || language;

i18n.on('languageChanged', (language) => { document.documentElement.lang = LOCALES[language] || LOCALES['fr-BE']; });

//? Résolue quand la langue active est chargée : index.js l'attend avant d'importer l'application,
//? dont beaucoup de modules appellent i18n.t dès leur import
export const i18nReady = i18n.use(backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: Object.keys(LOCALES),
        fallbackLng: 'fr-BE',
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'i18nextLng', // Lu aussi par App.js
            caches: ['localStorage'],
            convertDetectedLanguage
        },
        // La clé est le texte français : ni « : » ni « . » ne doivent la découper
        nsSeparator: false,
        keySeparator: false,
        // Valeur vide (pas encore traduite dans Tolgee) : on affiche le français plutôt qu'un blanc
        returnEmptyString: false,
        // React échappe déjà le texte. Un i18n.t interpolé ne doit jamais finir dans une chaîne HTML (innerHTML, setContent…)
        interpolation: { escapeValue: false },
        showSupportNotice: false
    });

export default i18n;
